import { CurrencyPipe, DecimalPipe, PercentPipe } from "@angular/common";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CurvaAbcService } from "../curva-abc-service/curva-abc.service";
import { ConversaoLibraConverte } from "./../../../../shared/conversao-libra/conversao-libra-converte";
import { Filtros } from "./../../../../shared/crud/Filtro/Filtros";
import { ListaBase } from "./../../../../shared/crud/ListaBase";
import { ExportExcelService } from "./../../../../shared/excel-service/export-excel.service";

@Component({
  selector: "app-curva-abc-lista",
  templateUrl: "./curva-abc-lista.component.html",
  styles: [
    `
      .text-right {
        text-align: right;
      }
    `,
  ],
  styleUrls: ["./curva-abc-lista.component.css"],
})
export class CurvaAbcListaComponent extends ListaBase implements OnInit {
  nomeDealer: string
  quantidadeDealer: number = 0
  totalCurvaAbc: number = 0
  totalCurvaA: number = 0
  totalCurvaB: number = 0
  totalCurvaC: number = 0
  totalCurvaD: number = 0
  totalPercentualA: number = 0;
  totalPercentualB: number = 0;
  totalPercentualC: number = 0;
  totalPercentualD: number = 0;
  totalPercentualOutros: number = 0
  totalOutros: number = 0
  carregando = false;
  parametrosFiltro: any;
  filtors: any = {};
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  cols: any[];
  _selectedColumns: any[];
  filtroconsolidado = false;
  filtropecas = true;
  filtroroupas = true;
  filtroacessorios = true;
  titulo = "PCA-CONSOLIDADO";
  tipo: any;
  data: any;
  tempDados: any;
  subscription;

  dadosTranslate = {
    "Nome Dealer": "estoque.curvaABC.nomeDealer",
    Outros: "estoque.curvaABC.outros",
    Brasil: "estoque.curvaABC.brasil",
  };


  constructor(
    service: CurvaAbcService,
    toast: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private currency: CurrencyPipe,
    private number: DecimalPipe,
    private percent: PercentPipe,
    private conversaoLibraConverte: ConversaoLibraConverte
  ) {
    super(service, toast, router);
    this.filtros = {};
    this.nomeModulo = "curva-abc";
  }

  @Input() set carregar(valores: any[]) {
    if (valores.length > 0) {
      this.limparFiltros();
      valores.forEach((item) => {
        new FiltroDealer(new FiltroEspecifico(null)).gerar(item, this.filtros);
      });
    } else {
      this.limparFiltros();
    }
  }

  ngOnInit(): void {
    this.setaValorData(null, null);
    this.buscar();
    this.cols = [
      { field: "codigo_dealer", header: "Dealer" },
      { field: "nome_dealer", header: "estoque.curvaABC.nomeDealer" },
      { field: "curva_a", header: "A", type: this.currency, arg1: " " },
      { field: "percentual_a", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "curva_b", header: "B", type: this.currency, arg1: " " },
      { field: "percentual_b", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "curva_c", header: "C", type: this.currency, arg1: " " },
      { field: "percentual_c", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "curva_d", header: "D", type: this.currency, arg1: " " },
      { field: "percentual_d", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "outros", header: "estoque.curvaABC.outros", type: this.currency, arg1: " " },
      { field: "percentual_outros", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "total", header: "Total", type: this.currency, arg1: " " },
    ];

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (_event: LangChangeEvent) => {
        this.buscar();
      }
    );
    //fimConversaolibra

    this._selectedColumns = this.cols;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter((col) => val.includes(col));
  }

  setaValorData(data: any, tipo: any) {
    //set data
    if (data === undefined || data === null) {
      this.data = this.dataAtualFormatada();
    } else {
      this.data = data;
    }
    //set tipo
    if (tipo === undefined || tipo === null) {
      this.tipo = [1, 2, 3];
    } else {
      this.tipo = tipo;
    }

    this.filtros = { data: this.data, tipo: this.tipo };
  }

  dataAtualFormatada() {
    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {
          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.carregando = true
    this.service.buscar(objFiltro).then((res) => {
      this.tempDados = res;
      this.carregando = false
      this.calculandoTotal(res)
    });
  }

  calculandoTotal(res) {
    this.quantidadeDealer = res.totalDealers;
    this.nomeDealer = 'Brasil';
    this.totalCurvaA = res.totalCurvaA
    this.totalCurvaB = res.totalCurvaB
    this.totalCurvaC = res.totalCurvaC
    this.totalCurvaD = res.totalCurvaD
    this.totalPercentualA = res.totalPercentualA;
    this.totalPercentualB = res.totalPercentualB;
    this.totalPercentualC = res.totalPercentualC;
    this.totalPercentualD = res.totalPercentualD;
    this.totalPercentualOutros = res.totalPercentualOutros
    this.totalOutros = res.totalOutros
    this.totalCurvaAbc = res.totalCurvaAbc
  }

  consolidado() {
    this.filtroconsolidado = false;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = [1, 2, 3];


    this.titulo = "PCA-CONSOLIDADO";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  pecas() {
    this.filtroconsolidado = true;
    this.filtropecas = false;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = 3;


    this.titulo = "PEÇAS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  roupas() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = false;
    this.filtroacessorios = true;
    this.tipo = 2;
    this.titulo = "ROUPAS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  acessorios() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = false;
    this.tipo = 1;
    this.titulo = "ACESSÓRIOS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial || this.filtros.data_final;
  }

  limparFiltros(): any {
    this.filtros.dealers = "";
    this.filtros.data_inicial = null;
    this.filtros.data_final = null;
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  getTranslate(value) {
    if (value.nome_dealer === "Calculando...") {
      return (value.nome_dealer = "estoque.pcaDashboard.calculando");
    }

    return this.dadosTranslate[value];
  }

  AlteraHeader(header) {
    if (header === "estoque.curvaABC.outros") {
      return "text-danger";
    }
  }

}

abstract class GerarFiltro {
  proximoGerador: GerarFiltro;

  constructor(proximoGerador: GerarFiltro) {
    this.proximoGerador = proximoGerador;
  }
  public abstract gerar(item: any, filtros: any);
}

class FiltroDealer extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    if (item.chave === "dealers") {
      const itens: string[] = [];
      item.valor.forEach((element) => {
        itens.push(element);
      });
      filtros.dealers = itens;
    } else {
      this.proximoGerador.gerar(item, filtros);
    }
  }
}

class FiltroEspecifico extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    filtros[item.chave] = item.valor;
  }
}
